/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { PermitListAuthDisplay } from "cms/components/components/permit-list-auth/display";
import { PermitListAuthEditor } from "cms/components/components/permit-list-auth/edit";
import { getComponentZoneLayout } from "cms/components/components/component";

function PermitListComponent (props) {
    
    const { ...everything } = props;
    const displayText = "A list of publicly visible permits will be shown here.";
    const zoneProps = {
        ...everything,
        displayComponent: <PermitListAuthDisplay text={displayText} />,
        editComponent: <PermitListAuthEditor showCheckbox={false} />,
    };
    return getComponentZoneLayout(zoneProps);
}

PermitListComponent.displayName = "PermitListComponent";
export { PermitListComponent };
